import { AuthAPI } from "../infrastructure/api/auth.api";
import { refreshIdToken } from "./session";

/** Start MFA enrolment. Returns the secret and its QR code. */
export async function startMfaSetup() {
    const { data } = await AuthAPI.mfaSetup();
    return data;
}

/**
 * Confirm MFA enrolment with a code from the authenticator app. The server
 * then requires the MFA claim on every therapist request, and the session
 * carries it only once the ID token refreshes, so it is refreshed here: a
 * caller that skipped it would be signed out by its very next request.
 */
export async function enableMfa(totpCode: string) {
    const { data } = await AuthAPI.mfaEnable({ totp_code: totpCode });
    await refreshIdToken();
    return data;
}

/** Turn MFA off; the password confirms it is the account holder. */
export async function disableMfa(password: string): Promise<void> {
    await AuthAPI.mfaDisable({ password });
}
